import { Redirect, Route } from 'react-router-dom';
import routes from 'config/routes';

const SignUpRoute = ({ children, ...rest}) => {
  const userData = localStorage.getItem('userData');

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const isRegisteringCompany = location.pathname === routes.register.company.root;
        let canAccess = isRegisteringCompany ? location.state?.stepNb === 1 && userData : true;

        return canAccess ? children : <Redirect to={{ pathname: routes.home.root, state: { from: location } }} />
      }}
    />
  );
}

export default SignUpRoute;
